module.exports = __webpack_public_path__ + "static/business-cards-81e4611828ae3a8b167c0830879b948b.png";